import { ChangeEvent, FormEvent } from 'react';

export function handleChange(callback?: (s: string) => void) {
  return function (e: ChangeEvent<HTMLInputElement>): void {
    if (callback) {
      callback(e.target.value);
    }
  };
}

export const handleCheck =
  (cb: (value: boolean) => void) =>
  (e: FormEvent<HTMLInputElement>): void => {
    cb(e.currentTarget.checked);
  };

export function handleNumberChange(callback: (data: number) => void) {
  return function (text: string): void {
    callback(parseInt(text.replace(/[^0-9]/g, ''), 10));
  };
}

/// Valid windows file name, linux is less restrictive
const folderNameInvalidCharactersRegex = /^(?!\.)(?!com[0-9]$)(?!con$)(?!lpt[0-9]$)(?!nul$)(?!prn$)[^\|\*\?\\:<>/$"]*[^\.\|\*\?\\:<>/$"]*$/;

export function handleFolderNameChange(callback: (data: string) => void) {
  return function (text: string): void {
    if (text.match(folderNameInvalidCharactersRegex)) {
      callback(text);
    }
  };
}
